
import axios from "axios";

const API_BASE_URL = import.meta.env.VITE_COUNSELLOR_API_BASE_URL;

export const getAllDoctors = async (userId, account_id) => {
  try {
    const response = await axios.get(`${API_BASE_URL}/doctors?user_id=${userId}&app_name=echobuddy&account_id=${account_id}`);
    return response.data;
  } catch (error) {
    console.error("❌ Error fetching doctors:", error);
    throw error;
  }
};

// Fetch a single doctor by ID
// export const getDoctorById = async (id) => {
//   try {
//     const response = await axios.get(`${API_BASE_URL}/doctors/${id}`);
//     return response.data;
//   } catch (error) {
//     console.error(`Error fetching doctor with id ${id}:`, error);
//     throw error;
//   }
// };

// Example: Create a new doctor
export const createDoctor = async (doctorData) => {
  try {
    const response = await axios.post(`${API_BASE_URL}/doctor`, doctorData);
    return response.data;
  } catch (error) {
    console.error("Error creating doctor:", error);
    throw error;
  }
};

// Example: Update doctor by ID
export const updateDoctor = async (id, doctorData) => {
  try {
    const response = await axios.put(`${API_BASE_URL}/doctor/${id}`, doctorData);
    return response.data;
  } catch (error) {
    console.error(`Error updating doctor with id ${id}:`, error);
    throw error;
  }
};

// Example: Delete doctor by ID
export const deleteDoctor = async (id) => {
  try {
    const response = await axios.delete(`${API_BASE_URL}/doctor/${id}`);
    return response.data;
  } catch (error) {
    console.error(`Error deleting doctor with id ${id}:`, error);
    throw error;
  }
};

export const getDoctorSlots = async (doctorId, startDate, endDate, isBooked = false) => {
  try {
    const response = await axios.get(
      `${API_BASE_URL}/doctors/${doctorId}/slots`,
      {
        params: {
          start_date: startDate,
          end_date: endDate,
          is_booked: isBooked
        },
      }
    );
    return response.data; // return the actual data
  } catch (error) {
    console.error("Error fetching doctor slots:", error);
    throw error;
  }
};